export const FEATURE_TOGGLES = {
  TEST_TOGGLE: 'test-toggle',
  TOTAL_REVENUE_STRATEGY_TAB: 'total-revenue-strategy-tab',
  UNIFIED_HOTEL_VIEW: 'unified-hotel-view', // Cleanup ticket: CPS-541
  PRICING_MANAGER_OVERBOOKING_AUTOPILOT:
    'pricing-manager-overbooking-autopilot', // Cleanup ticket: COA-3299
  ROLLING_WINDOW_REFERENCE_RATES: 'rolling-window-reference-rates', // Cleanup ticket: COA-3480
  STAY_RESTRICTION_RATE_GROUP: 'stay-restriction-rate-group', // Cleanup ticket: COA-3787
  BI_NET_REVENUE: 'bi-net-revenue', // Cleanup ticket: TOR-1214
  NET_REVENUE_SETTINGS: 'net-revenue-settings',
  USER_ACCESS: 'user-access', // Cleanup ticket: CPS-747
  BI_SNAPSHOTS: 'business-intelligence-snapshots', // Cleanup ticket: PF-2226
  DAY_OVERRIDE_MODAL_RESTRICTIONS_TAB: 'day-override-modal-restrictions-tab',
  PRICING_MANAGER_OVERBOOKING_FAILURE: 'pricing-manager-overbooking-failure', // Cleanup ticket: COA-3546
  CUSTOM_PROPERTY_TAGS: 'business-intelligence-custom-property-tags',
  SMART_INSIGHTS_365_UPSELL: 'smart-insights-365-upsell',
  REACT_SETTINGS_SIDE_PANEL: 'react-settings-side-panel',
  REACT_HEADER: 'react-header',
  PRICING_MANAGER_SEASONAL_ROOM_HIERARCHY:
    'pricing-manager-seasonal-room-hierarchy', // Cleanup ticket: INDU-1680
  PRICING_MANAGER_DEEP_DISCOUNT: 'pricing-manager-deep-discount', // Cleanup ticket: COA-3830
} as const;
export type FeatureToggle =
  (typeof FEATURE_TOGGLES)[keyof typeof FEATURE_TOGGLES];
